import {Component, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AuthService} from '../../services/auth.service';
import {SYSTEM_NAME} from '../../shared/constants/constants';
import {NotificationService} from 'src/app/services/notification.service';
import {Apollo} from "apollo-angular";
import {GET_CAPTCHA, VERIFY_CAPTCHA_MUTATION} from "./login.graphql";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loading = false;
  subscription: Subscription = new Subscription();
  staffLoginForm: FormGroup;
  userType: string;
  title: string;
  showPassword: boolean;
  sessionExpired: boolean;
  hide: boolean = false;
  message = 'Welcome again to';
  optionValue: string ='nidaValue';
  captchaVerify: boolean = false
  captchaText: ""
  captchaImage: any
  captchaInput: string = ""
  captchaErrMsg: string = ""


  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private notificationService: NotificationService,
    private apollo: Apollo,
  ) {
  }

  ngOnInit(): void {

    this.title = SYSTEM_NAME;
    this.staffLoginForm = this.fb.group({
      email: [null],
      password: [null],
    });
    this.generateCaptcha()
  }

  generateCaptcha(){
    this.apollo
      .query({
        query: GET_CAPTCHA,
        fetchPolicy: "network-only"
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data)[0];
        result = result.getCaptcha;
        if (result?.response.code == '9000') {
          this.captchaText = result.data?.captchaText;
          this.captchaImage = result.data?.captchaImage;
        }
      })
  }

  verifyCaptcha(){
    if (this.captchaInput?.toUpperCase() === this.captchaText?.toUpperCase()) {
      this.captchaErrMsg = ""
      this.apollo
        .mutate({
          mutation: VERIFY_CAPTCHA_MUTATION,
          fetchPolicy: "network-only",
          variables: {
            captchaText: this.captchaText,
            userInput: this.captchaInput
          }
        })
        .toPromise()
        .then((data) => {
          let result: any = Object.values(data)[0];
          result = result.verifyCaptchaMutation;
          console.log(result)
          if (result?.response.code == '9000') {
            this.captchaVerify = true
          }
        })

    } else {
      this.captchaErrMsg = "They do not match"
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  async login(formValue: { email: string; password: string }) {
    await this.authService.login(formValue.email, formValue.password).catch((err) => {
      this.notificationService.errorMessage("Invalid credentials")
    });
  }



  changedValue(value: string) {
    if (value === 'emailValue') {
      this.optionValue = value;
       this.staffLoginForm.patchValue({email:null})
    } else if (value === 'nidaValue') {
      this.optionValue = value;
      this.staffLoginForm.patchValue({email:null})
    }
  }


}
